import { commonActions } from '@codametrix/ui-common';
import { createAction } from '@reduxjs/toolkit';
export const inProgress = createAction(commonActions.CMxApplication.IN_PROGRESS, ()=>({
        payload: undefined,
        meta: {
            user: true
        }
    }));
const exportable = {
    inProgress
};
export default exportable;
